import { render, staticRenderFns } from "./registration_massive.html?vue&type=template&id=63ede5f1&scoped=true&external"
import script from "./registration_massive.vue?vue&type=script&lang=js"
export * from "./registration_massive.vue?vue&type=script&lang=js"
import style0 from "./registration_massive.vue?vue&type=style&index=0&id=63ede5f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ede5f1",
  null
  
)

export default component.exports